import makeVueModal from '@/views/modal/make_vue_modal';

import track from '@/helpers/track';

let callModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (callModal) {
    callModal.destroy();
    callModal = null;
  }
});

pageLoad('pages_promo', () => {
  $('article.v4.slide_4 .lead').one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    callModal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/call_lead'),
        props: {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('lead-type'),
          trackEvent: $node.data('track-event'),
          trackEventLocation: $node.data('track-event-location'),
          privacyUrl: $node.data('privacy_url'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url'),
          titleOverride: $node.data('title-override'),
          noteOverride: $node.data('note-override'),
          rentNote: $node.data('rent-note')
        }
      },
      isCloseOnSubmit: true,
      onShow: () => {
        track({
          event: 'callback_form_opened',
          form_location: $node.data('track-event-location')
        });
      }
    })
      .show();
  });
});
